export enum ArtikelsuchePreisanzeigeModus {
    Keine,
    UVP,
    Netto,
    Kundenindividuell,
}
